import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { NavLink } from 'react-router-dom';

// Ikony
const ListIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"></path>
  </svg>
);

const StudyIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"></path>
  </svg>
);

const SettingsIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"></path>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
  </svg>
);

const LogoutIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path>
  </svg>
);

const CloseIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
  </svg>
);

const InstallIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path>
  </svg>
);

const Sidebar = ({ onLogout, onClose }) => {
  const location = useLocation();
  const [isMobile, setIsMobile] = React.useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallButton, setShowInstallButton] = useState(true);

  // Sprawdzanie rozmiaru ekranu przy ładowaniu i zmianie rozmiaru okna
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);
    
    return () => {
      window.removeEventListener('resize', checkIfMobile);
    };
  }, []);

  // Obsługa instalacji PWA
  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstallButton(true);
    };

    window.addEventListener('beforeinstallprompt', handler);

    // Sprawdź czy aplikacja jest już zainstalowana
    window.addEventListener('appinstalled', () => {
      setShowInstallButton(false);
    });

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) {
      console.log('Nie można zainstalować aplikacji - deferredPrompt jest null');
      return;
    }

    try {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      console.log(`Instalacja ${outcome === 'accepted' ? 'zaakceptowana' : 'odrzucona'}`);
      
      if (outcome === 'accepted') {
        setShowInstallButton(false);
      }
    } catch (error) {
      console.error('Błąd podczas instalacji:', error);
    }
    setDeferredPrompt(null);
  };

  const NavItem = ({ to, icon, label, disabled, onClose }) => {
    const isActive = location.pathname === to;
    const baseClasses = "flex items-center px-4 py-2 text-sm rounded-md transition-colors mb-1";
    const activeClasses = "bg-primary-100 text-primary-800";
    const inactiveClasses = "text-neutral-600 hover:bg-neutral-100";
    const disabledClasses = "text-neutral-400 cursor-not-allowed";
    
    const handleClick = (e) => {
      if (isMobile && !disabled && onClose) {
        onClose();
      }
    };

    return (
      <li>
        {disabled ? (
          <span className={`${baseClasses} ${disabledClasses}`}>
            {icon}
            <span className="ml-3">{label}</span>
          </span>
        ) : (
          <Link 
            to={to} 
            className={`${baseClasses} ${isActive ? activeClasses : inactiveClasses}`}
            onClick={handleClick}
          >
            {icon}
            <span className="ml-3">{label}</span>
          </Link>
        )}
      </li>
    );
  };

  return (
    <div className="flex flex-col w-60 h-full p-4 bg-white border-r border-neutral-200 shadow-lg">
      <div className="flex items-center justify-between mb-6">
        <span className="text-lg font-semibold text-primary-600 ps-4">Klint</span>
        {isMobile && (
          <button 
            className="p-1 rounded-md hover:bg-neutral-100"
            onClick={() => {
              // Znajdź przycisk toggle w MainLayout i kliknij go
              const toggleButton = document.querySelector('[aria-label="Toggle menu"]');
              if (toggleButton) toggleButton.click();
            }}
            aria-label="Close menu"
          >
            <CloseIcon />
          </button>
        )}
      </div>
      
      <nav className="flex-1">
        <ul>
          <NavItem to="/lists" icon={<ListIcon />} label="Listy słówek" onClose={onClose} />
          <NavItem to="/study" icon={<StudyIcon />} label="Nauka" onClose={onClose} />
          <NavItem to="/settings" icon={<SettingsIcon />} label="Ustawienia" onClose={onClose} />
        </ul>
      </nav>
      
      <div className="pt-4 mt-auto border-t border-neutral-200">
        {showInstallButton && (
            <button
              onClick={handleInstallClick}
              className="flex items-center w-full px-4 py-2 text-sm text-neutral-600 rounded-md hover:bg-neutral-100 transition-colors"
            >
              <InstallIcon />
              <span className="ml-3">Zainstaluj aplikację</span>
            </button>
        )}
        <button 
          className="flex items-center w-full px-4 py-2 text-sm text-neutral-600 rounded-md hover:bg-neutral-100 transition-colors"
          onClick={onLogout}
        >
          <LogoutIcon />
          <span className="ml-3">Wyloguj</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar; 